<horizon-profile-toolbar (logoutEvent)="logout()"></horizon-profile-toolbar>

<mat-card>
  <mat-card-header>
    <mat-card-title data-cy="select-profile-title">Profils disponibles</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-selection-list role="list" [multiple]="false">
      @for (profile of profiles$ | async; track profile;) {
        <mat-list-option role="listitem" checkboxPosition="before" [attr.data-cy]="'profile-' + profile.id" (click)="selectProfile(profile)">
          <app-profile-item [profile]="profile"></app-profile-item>
        </mat-list-option>
      }
    </mat-selection-list>
  </mat-card-content>
</mat-card>
